export default __webpack_public_path__ + "static/media/shape-3.135ca4c7.svg";